import { render, staticRenderFns } from "./StudentStudyClassManage.vue?vue&type=template&id=1c6a9ff6&scoped=true"
import script from "./StudentStudyClassManage.vue?vue&type=script&lang=js"
export * from "./StudentStudyClassManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c6a9ff6",
  null
  
)

export default component.exports